import { motion } from 'motion/react';
import SpecialistTabs from './SpecialistTabs';
import PlanNavigation from './PlanNavigation';
import type { PlanState } from '@/types';
interface PlanContainerProps {
  planState: PlanState;
  onAdvance: () => void;
}

const PlanContainer = ({ planState, onAdvance }: PlanContainerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-4 p-5 rounded-2xl bg-white dark:bg-slate-800 border border-amber-200 dark:border-amber-800/50 shadow-card"
    >
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
          <span className="text-sm">📋</span>
        </div>
        <div>
          <span className="text-xs font-bold text-amber-600 dark:text-amber-400 uppercase tracking-wider">
            Business Plan
          </span>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Step-by-step specialist guidance
          </p>
        </div>
      </div>

      <SpecialistTabs currentMode={planState.mode} />
      <PlanNavigation
        navigation={planState.navigation}
        canAdvance={planState.canAdvance}
        onAdvance={onAdvance}
      />
    </motion.div>
  );
};

export default PlanContainer;
